// The portal is embedded in an iframe on eBay and VITE EN VOGUE. The parent
// origin arrives as the URL fragment, and the parent resizes the frame from
// the height we post back. Previously jquery.ba-postmessage; postMessage is
// native now.
export function parentOrigin() {
  try {
    return decodeURIComponent(window.location.hash.replace(/^#/, "")) || null;
  } catch {
    return null;
  }
}

export function postHeight(target = document.body) {
  const origin = parentOrigin();
  if (!origin || window.parent === window) return;
  const height = Math.ceil(target.getBoundingClientRect().height);
  try {
    window.parent.postMessage({ if_height: height }, origin);
  } catch {
    /* parent went away, or origin mismatch; nothing useful to do */
  }
}

// Re-post whenever the content resizes, which is what the accordion does.
export function watchHeight(el) {
  if (!el) return () => {};
  postHeight(el);
  const observer = new ResizeObserver(() => postHeight(el));
  observer.observe(el);
  return () => observer.disconnect();
}
